import {Component, OnInit, ViewChild} from '@angular/core';
import {Tank, User} from 'shared';
import {TankService} from '../../stores/tank.service';
import DataSource from 'devextreme/data/data_source';
import historyIcon from '@iconify/icons-mdi/history';
import {SensorHistoryPopupComponent} from '../../sensors/sensor-history-popup/sensor-history-popup.component';
import Form from 'devextreme/ui/form';
import {merge} from 'lodash';

@Component({
  selector: 'app-tanks-grid',
  templateUrl: './tanks-grid.component.html',
  styleUrls: ['./tanks-grid.component.scss']
})
export class TanksGridComponent implements OnInit {
  ds: DataSource;
  canEdit: boolean;
  canAdd: boolean;
  canDelete: boolean;
  canEditSensors: boolean;
  historyIcon = historyIcon;

  @ViewChild('sensorHistory')
  sensorHistory: SensorHistoryPopupComponent;

  @ViewChild('sensorChanges')
  sensorChanges: SensorHistoryPopupComponent;

  private current: Tank;
  public testButton;

  form: any;
  changes = [];

  constructor(
    private service: TankService,
    private user: User,
  ) {
    // Data source
    this.ds = service.newDataSource();

    // Permissions
    this.canEdit = user.can('edit tanks');
    this.canAdd = user.can('add tanks');
    this.canDelete = user.can('delete tanks');
    this.canEditSensors = user.can('edit sensors');

    this.testButton = {
      stylingMode: 'contained',
      icon: 'video',
      onClick: (e) => {
        const result = this.form.validate();
        if (result.isValid) {
          e.component.option('disabled', true);
          this.current = merge(this.current, this.changes.length > 0 ? this.changes[0].data : {});
          this.service.testSensor(this.current).subscribe((value) => {
            alert(value);
            e.component.option('disabled', false);
          });
        }
      }
    };
    this.showLevelChanges = this.showLevelChanges.bind(this);
    this.showLevelHistory = this.showLevelHistory.bind(this);
  }

  ngOnInit(): void {
  }

  showLevelHistory(e) {
    const sensor = e.row.data.sensors.find(s => s.name === 'ADC');
    if (!sensor) {
      return;
    }
    this.sensorHistory.showHistory(sensor);
  }

  onEdit(e: any) {
    this.current = Object.assign({}, e.data);
  }

  formContentReady = (e) => {
    this.form = e.component;
  }

  showLevelChanges(e) {
    const sensor = e.row.data.sensors.find(s => s.name === 'ADC');
    if (!sensor) {
      return;
    }
    this.sensorChanges.showHistory(sensor, true);
  }
}
